var _path, _g, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaregiver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3644_32023",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 22,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.13745H27V29.0001H5V2.13745Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3644_32023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5 15.5002C26.1039 19.8578 19.8211 25.1002 17.2281 27.09C16.5682 27.5963 15.6727 27.6017 15.0068 27.1034C12.3613 25.1238 5.89704 19.8676 5.5 15.5002C5.5 9.82717 9.83422 2.00024 16.1223 2.00024C22.4103 2.00024 26.5 9.82717 26.5 15.5002Z",
    fill: "#F9A825"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 11,
    fill: "#F9A825"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 9,
    fill: "#F9A825"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18L15.275 17.3624C14.4333 16.6185 13.7375 15.9768 13.1875 15.4373C12.6375 14.8978 12.2 14.4135 11.875 13.9843C11.55 13.5552 11.3229 13.1608 11.1938 12.8011C11.0646 12.4414 11 12.0736 11 11.6975C11 10.9292 11.2625 10.2875 11.7875 9.77248C12.3125 9.25749 12.9667 9 13.75 9C14.1833 9 14.5958 9.08992 14.9875 9.26975C15.3792 9.44959 15.7167 9.703 16 10.03C16.2833 9.703 16.6208 9.44959 17.0125 9.26975C17.4042 9.08992 17.8167 9 18.25 9C19.0333 9 19.6875 9.25749 20.2125 9.77248C20.7375 10.2875 21 10.9292 21 11.6975C21 12.0736 20.9354 12.4414 20.8063 12.8011C20.6771 13.1608 20.45 13.5552 20.125 13.9843C19.8 14.4135 19.3625 14.8978 18.8125 15.4373C18.2625 15.9768 17.5667 16.6185 16.725 17.3624L16 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregiver);
export default __webpack_public_path__ + "static/media/caregiver.54b2ee926bccf14433f83ac38e93b2af.svg";
export { ForwardRef as ReactComponent };